import {Component, Input, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {Evento} from "./models/evento";
import {TarefaService} from "../../../modules/trabalho/services/tarefa-service";
import {ItemTarefa} from "../../../modules/trabalho/models/lista-tarefa";
import {CompromissoService} from "../../services/compromisso.service";
import {DetalhesTarefasComponent} from "../detalhes-tarefas/detalhes-tarefas.component";
import {StatusTarefa} from "../../../modules/trabalho/enums/status-tarefa";

@Component({
  selector: 'app-calendario',
  standalone: false,
  templateUrl: './calendario.component.html',
  styleUrl: './calendario.component.css'
})
export class CalendarioComponent implements OnInit {
  @Input() evento = false;
  @Input() titulo = '';
  eventos: Evento[] = [];
  title = '';

  @ViewChild(DetalhesTarefasComponent) detalhesTarefasComponent: DetalhesTarefasComponent;

  showModalDetalhes = false;

  public fecharModalDetalhes(): void {
    this.showModalDetalhes = false;
  }

  public buscarDetalheTarefa(id: number){
    this.showModalDetalhes = true;
    this.detalhesTarefasComponent.buscarTarefaPorId(id);
  }

  monthNames: string[] = [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
  ];

  currentDate: Date = new Date();
  viewMonth: number = this.currentDate.getMonth();
  viewYear: number = this.currentDate.getFullYear();
  today: number = this.currentDate.getDate();
  weeks: any[][] = [];

  constructor(
    private tarefaService: TarefaService,
    private compromissoService: CompromissoService
  ) {
    this.buscarTarefasDoMes();
  }

  ngOnInit(): void {
    this.buscarTarefasDoMes();
    this.generateCalendar();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.generateCalendar();
  }

  private generateCalendar(): void {
    const firstDay = new Date(this.viewYear, this.viewMonth, 1);
    const lastDay = new Date(this.viewYear, this.viewMonth + 1, 0);
    const startDayOfWeek = firstDay.getDay();
    const totalDays = lastDay.getDate();

    this.title = `${this.titulo} - ${this.monthNames[this.viewMonth]} ${this.viewYear}`;
    let weeks = [];
    let week = new Array(7).fill(null);
    let day = 1;

    for (let i = 0; i < 7; i++) {
      if (i >= startDayOfWeek) {
        week[i] = this.buildDayObject(day++);
      }
    }
    weeks.push(week);

    while (day <= totalDays) {
      week = new Array(7).fill(null);
      for (let i = 0; i < 7 && day <= totalDays; i++) {
        week[i] = this.buildDayObject(day++);
      }
      weeks.push(week);
    }

    this.weeks = weeks;
  }

  private buildDayObject(day: number) {
    const dateStr = `${this.viewYear}-${(this.viewMonth + 1).toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
    return {
      day,
      dataComparacao: dateStr
    };
  }

  goToPreviousMonth(): void {
    if (this.viewMonth === 0) {
      this.viewMonth = 11;
      this.viewYear--;
    } else {
      this.viewMonth--;
    }
    this.generateCalendar();
  }

  goToNextMonth(): void {
    if (this.viewMonth === 11) {
      this.viewMonth = 0;
      this.viewYear++;
    } else {
      this.viewMonth++;
    }
    this.generateCalendar();
  }

  isToday(dayObj: any): boolean {
    return dayObj?.day === this.today &&
      this.viewMonth === new Date().getMonth() &&
      this.viewYear === new Date().getFullYear();
  }

   buscarTarefasDoMes(){
    this.tarefaService.minhasTarefas().subscribe(retorno => {
      if(retorno.sucesso){
        let eventos = this.converterTarefasParaEventos(retorno.dados.itens);
        this.eventos = eventos;
      }
    });
  }

  private converterTarefasParaEventos(tarefas: ItemTarefa[]): Evento[] {
    let eventos: Evento[] = [];

    for(let tarefa of tarefas){
      const date = new Date(tarefa.dataInicial);
      const hora = date.getHours().toString().padStart(2, '0'); // Extrai a hora com 2 dígitos
      const minutos = date.getMinutes().toString().padStart(2, '0'); // Extrai os minutos com 2 dígitos
      const horario = `${hora}:${minutos}`; // Format

      let evento = new Evento();
      evento.data = new Date(tarefa.dataInicial).toISOString().split('T')[0];
      evento.hora = horario;
      evento.descricao = tarefa.descricao;
      evento.id = tarefa.id;
      evento.atrasada = tarefa.atrasada;
      evento.finalizada = tarefa.finalizada;


      eventos.push(evento);

    }
    return eventos.sort((a, b) => {
      // First sort by date
      const dateComparison = a.data.localeCompare(b.data);
      if (dateComparison !== 0) {
        return dateComparison;
      }
      // If dates are equal, sort by time
      return a.hora.localeCompare(b.hora);
    });
  }

  getEventosFiltrados(dataComparacao: string): Evento[]{
    if(this.eventos.length === 0)
      return [];

    let eventosFiltrados = this.eventos.filter(evento => evento.data === dataComparacao);
    return eventosFiltrados;
  }

  abrirNovoCompromisso(dayObj: any): void {
    if (dayObj) {
      // Usar o serviço para abrir o modal de novo compromisso com a data selecionada
      this.compromissoService.abrirNovoCompromisso(dayObj.dataComparacao);
    }
  }
}
